export type Photo = {
    uuid: string,
    status: PhotoStatus,
    data: string,
    assessment: PhotoAssessment
};

export type PhotoAssessment = {
    compliant: boolean,
    warnings: string[]
};

export enum PhotoStatus {
    Empty = 'empty',
    Draft = 'draft',
    Accepted = 'accepted',
    Exported = 'exported',
}